import {
    TypeProductCardWithoutUnresolvableLinksResponse,
    TypeProductContentHousingWithoutUnresolvableLinksResponse,
} from '@/features/contentful/_generated';
import TextCardBlock from '@/features/contentful/components/Cards/TextCardBlock';
import TileContainer from '@/features/contentful/components/Tile/TileContainer';
import TileHeader from '@/features/contentful/components/Tile/TileHeader';
import { TPosition } from '@/types/types';
import classNames from 'classnames';
import React from 'react';

interface ITextCardProps {
    component: TypeProductContentHousingWithoutUnresolvableLinksResponse;
    id?: string;
}

const TextCard: React.FC<ITextCardProps> = ({ component: { fields }, id }) => {
    const items = fields?.ourComponent?.map((item) => {
        const productItem = item as TypeProductCardWithoutUnresolvableLinksResponse;
        return {
            title: productItem?.fields?.title,
            description: productItem?.fields?.content,
            key: productItem?.sys?.id,
        };
    });

    return (
        <TileContainer
            className={classNames({
                'tw-bg-bgSkyLight': fields?.backgroundColor === 'blue',
                'tw-bg-bgNavy': fields?.backgroundColor === 'dark blue',
            })}
            paddingTop={fields?.paddingTop}
            paddingBottom={fields?.paddingBottom}
        >
            <TileHeader
                id={id}
                title={fields?.title}
                subtitle={fields?.subtitle}
                isDarkMode={fields?.backgroundColor === 'dark blue'}
                titlePosition={fields?.titlePosition as TPosition}
                subtitlePosition={fields?.subtitlePosition as TPosition}
            />
            <div className="tw-flex tw-flex-wrap lg:tw-flex-nowrap tw-justify-center tw-gap-5">
                {items.map((item) => (
                    <TextCardBlock item={item} key={item.key} id={item.key} />
                ))}
            </div>
        </TileContainer>
    );
};

export default TextCard;
